import React from 'react'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';


const DatePickerComponent = ({maxDate,label,isFilterDisabled,handleChange,minDate,value}) => {
  
  return (
    <>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker 
            label={label}  
            maxDate={dayjs(maxDate)}
            minDate={dayjs(minDate)} 
            disabled={isFilterDisabled} 
            format="YYYY-MM-DD"
            value={dayjs(value)}
            onChange={(date) => {
              const localDate = new Date(date).toLocaleDateString('en-US');
              handleChange(localDate);
            }}
            slotProps={{
              textField: {
                  readOnly: true,
                  error: false,
              },
          }}
          />
        </LocalizationProvider>
    </>
  )
}

export default DatePickerComponent